import { useCustom } from '@refinedev/core';
import { useMemo } from 'react';

/**
 * E57 · MyHiddenTools — the signed-in therapist's own hidden-tool set (My tools). Read by the My tools page, the client
 * page's tool row (through ClientToolNavigation, which carries `hiddenByMe`) and the pickers (Assign homework "What",
 * Use a tool). Empty = every tool on. A failed read hides nothing (the safe side: no tool goes missing).
 */
export const useMyHiddenTools = (enabled = true) => {
  const { data, isLoading, refetch } = useCustom<{ performer: string; hiddenTools: string[] }>({
    url: '',
    method: 'get',
    errorNotification: false,
    meta: { operation: 'myHiddenTools', fields: ['performer', 'hiddenTools'] },
    queryOptions: { enabled },
  });
  const hiddenTools = useMemo(() => data?.data?.hiddenTools ?? [], [data]);
  return { hiddenTools, isLoading: enabled && isLoading, refetch };
};
